import { FiltersCard } from 'src/admin/components/Cards/FiltersCard'
import { Grid } from '@mui/material'
import { useAppTranslation } from 'src/admin/core/hooks'
import { SearchField } from 'src/admin/core'
import { useEffect, useState } from 'react'

export type FiltersProps = {
  search?: string
}

const Filters: React.FC<{ onChange: (filters: FiltersProps) => void }> = ({ onChange }) => {
  const { label } = useAppTranslation()
  const [filters, setFilters] = useState<FiltersProps>({
    search: '',
  })

  useEffect(() => {
    onChange(filters)
  }, [filters])

  return (
    <FiltersCard>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <SearchField
            onChange={(query: string) => setFilters({ ...filters, search: query })}
            placeholder={label('MOSTRAR_LOS_QUE_COINCIDAD_CON')}
            width={'100%'}
          />
        </Grid>
      </Grid>
    </FiltersCard>
  )
}

export default Filters
